module.exports = __webpack_public_path__ + "img/picture_dxh.3e13df20.png";